// Show the first tab by default
// Show the first tab by default
$(document).ready(function(){
	var $carousel = $(".slider-gallery");
	$('ul.tabs li a').click(function(event){
		
   setTimeout(function() {
    $carousel.show()
      // resize after un-hiding Flickity
      .flickity("resize");
  }, 10);
		
      /*var selector = event.target.getAttribute('href');
      console.log(selector);
  // trigger resize on tab pane
    $(  selector + " .slider-gallery ").flickity();
    $(  selector + " .slider-gallery ").flickity('resize');*/
    //$ ( "#tab2 .flickity-button").trigger('click');
  
    
   });

  /* Logo slider */
  $('[data-logo-slider]').flickity({
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      initialIndex: 0
  });

  $('.related-products--slider').flickity({
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      initialIndex: 0
  });

  var elem = document.querySelector(".icon-bars");
  var flkty = new Flickity(elem, {
    prevNextButtons: false,
    contain: true,
    freeScroll: false,
    watchCSS: true,
    wrapAround: true,
    cellAlign: "center",
    groupCells: false,
    initialIndex: 0,
    pauseAutoPlayOnHover: false,
    autoPlay:
    elem?.getAttribute("data-slider-autoplay") !== "0"
      ? Number(elem?.getAttribute("data-slider-autoplay"))
      : false,
  });
  // Resume autoplay after interaction
  flkty.on("dragEnd", () => {
    flkty.playPlayer(); // Resume autoplay after dragging
  });
  flkty.on("pointerUp", () => {
    flkty.playPlayer(); // Resume autoplay after clicking
  });
  flkty.on("settle", () => {
    flkty.playPlayer(); // Resume autoplay after settling
  });
})

var elem_promotions = document.querySelector('.featured-promotions-slider-mobile');
if(elem_promotions) {
  var flkty = new Flickity( elem_promotions, {
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    groupCells: false,
    initialIndex: 0,
    autoplay:true,
    watchCSS:true

  });
}

var elem_text_icons = document.querySelector('.text-column-with-icons');
if(elem_text_icons) {
  var flkty = new Flickity( elem_text_icons, {
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    groupCells: false,
    initialIndex: 0,
    autoplay:true,
    watchCSS:true

  });
}

var elem_subcollection = document.querySelector('.list-collection-wrapper');
if(elem_subcollection) {
  var flkty = new Flickity( elem_subcollection, {
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    groupCells: true,
    groupCells: 2,
    initialIndex: 0,
    autoplay:false,
    watchCSS:true,
    wrapAround: true

  });
}

var elem_popular_products = document.querySelector('.related-product-list');
if(elem_popular_products) {
  var flkty = new Flickity( elem_popular_products, {
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    initialIndex: 0,
    autoplay:true,
    watchCSS:true,
    wrapAround: true

  });
}

var elem_collection_list = document.querySelector('.index-collection-list');
if(elem_collection_list) {
  var flkty = new Flickity( elem_collection_list, {
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    initialIndex: 0,
    autoplay:false,
    watchCSS:true,
    wrapAround: true

  });
}


if (template == 'product'){
  setTimeout(() => {
      console.log(template);
    // shipping timline
    const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    //const date = ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31"]
    const today = new Date();
    let name = month[today.getMonth()];
    /*console.log(name);*/
    //Order place date
    let todayDate = today.getDate();
    document.getElementById("currentdate").innerHTML = todayDate + '<span class="currentdate">' +name +'</span>';
    const options = { timeZone: "Australia/Sydney", timeStyle: 'short' };
    /*console.log(options);*/
    var time = today.toLocaleTimeString('en-GB', options);
    var  cuttoffTime = document.getElementById('cutofftime');
    textContent = cuttoffTime.textContent;
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var current_day = new Date();
    var dayName = days[current_day.getDay()];
    var shippingtime_text = textContent;
     var shippingtime_number = Number(shippingtime_text);
    var shippingtime = document.getElementById('shippingtime');
     var new_dispatched_date = new Date();
    console.log(new_dispatched_date);
    // console.log (dayName);
    
    //pre-order code //

    var eta_button = document.getElementById("preOrderDate");
    if(eta_button){
              eta_button_text = eta_button.textContent;
              var pre_order = "To Be Confirmed";
              if (eta_button_text.includes(pre_order)){
                  document.getElementById("dispatchdate").innerHTML = 'NA';
                  document.getElementById("delivereddate").innerHTML = 'NA';
              }          
              /*else if(eta_button_text.includes(pre_order) == false) {
                 var eta_date_content = eta_button.textContent;
                 var eta_button =  eta_date_content.substring(33);
                 if (eta_button){                    
                   var dateString = eta_button; // output - 04/08/2023   
                   var dateParts = dateString.split("/"); 
                    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); //Fri Aug 04 2023 00:00:00 GMT+0530 (India Standard Time)
                    let preorder_month = month[dateObject.getMonth()];
                    var preorder_fullfilmenttime = document.getElementById('fullfilmenttime');                          
                    document.getElementById("dispatchdate").innerHTML = dateObject.getDate() + '<span class="dispatcheddate">' + preorder_month + '</span>';
                    function getNextBusinessDay_delivery(delivery_date) {  
                        delivery_date = new Date(+delivery_date);
                        do {
                          delivery_date.setDate(delivery_date.getDate() + 1);
                        } while (!(delivery_date.getDay() % 6))
                        return delivery_date; 
                    }
                    var result = new_dispatched_date.setDate(new_dispatched_date.getDate() + shippingtime_number);
                    var getNextBusinessDayDelivery = getNextBusinessDay_delivery(dateObject);
                    const new_shipping_month = month[getNextBusinessDayDelivery.getMonth()];
                    const new_delivered_day_date = getNextBusinessDayDelivery.getDate();
                    document.getElementById("delivereddate").innerHTML = new_delivered_day_date + '<span class="delivereddate">'+new_shipping_month+'</span>';
                 }
              } */
    }
    else {
    
    // New code
    // get the next business day  
    console.log (current_day);

    console.log(`${time} <= ${textContent}`);
   
     if (time <= textContent){ 
      function getNextBusinessDay(date) {
        date = new Date(+date);
        do {
          date.setDate(date.getDate() + 1);
        } while (!(date.getDay() % 6))
        return date;
      }
      [new Date()].forEach(function(d) {
           /*console.log(d);
           console.log(d.toLocaleString() + ' : ' + getNextBusinessDay(d));*/
           new_dispatched_date = getNextBusinessDay(current_day);     
           const new_dispatched_day = new_dispatched_date.getDate();
           const new_dispatched_month = month[new_dispatched_date.getMonth()];
           var fullfilmenttime = document.getElementById('fullfilmenttime');
           fullFillmenttime_text = fullfilmenttime.textContent;
           var fullfilment_number = Number(fullFillmenttime_text);
           var shippingtime = document.getElementById('shippingtime');
           shippingtime_text = shippingtime.textContent;
           shippingtime_number = Number(shippingtime_text);
           let dispatchDate = [new_dispatched_day + fullfilment_number ];
           document.getElementById("dispatchdate").innerHTML = dispatchDate + '<span class="dispatcheddate">' + new_dispatched_month + '</span>';
      });


    
  
    }else{
        /*console.log('else = '+new Date());*/
         function getNextBusinessDay(date) {
          // Copy date so don't affect original
          date = new Date(+date);
          if (date.getDay() == 5 || date.getDay() == 6 || date.getDay() == 0){
            do {
              date.setDate(date.getDate() + 1);
            } while (!(date.getDay() % 6))
          }
          else{
            do {
              date.setDate(date.getDate() + 2);
            } while (!(date.getDay() % 6))
          }        
          return date;
        }
         new_dispatched_date = getNextBusinessDay(current_day);
         const new_dispatched_day = new_dispatched_date.getDate() ;
         const new_dispatched_month = month[new_dispatched_date.getMonth()];
         var fullfilmenttime = document.getElementById('fullfilmenttime');
         fullFillmenttime_text = fullfilmenttime.textContent;
         var fullfilment_number = Number(fullFillmenttime_text);
         shippingtime_text = shippingtime.textContent;
         shippingtime_number = Number(shippingtime_text);
         let dispatchDate = [new_dispatched_day + fullfilment_number ];
         document.getElementById("dispatchdate").innerHTML = dispatchDate + '<span class="dispatcheddate">' + new_dispatched_month +'</span>';      
      }


    // delivery date
      shippingtime_text = shippingtime.textContent;
      shippingtime_number = Number(shippingtime_text) - 1;
      var new_shipping_date = document.getElementById("dispatchdate");
      function getNextBusinessDay_delivery(delivery_date) {  
        delivery_date = new Date(+delivery_date);
        do {
          delivery_date.setDate(delivery_date.getDate() + 1);
        } while (!(delivery_date.getDay() % 6))
        return delivery_date; 
      }
      var result = new_dispatched_date.setDate(new_dispatched_date.getDate() + shippingtime_number);
      var getNextBusinessDayDelivery = getNextBusinessDay_delivery(result);
      const new_shipping_month = month[getNextBusinessDayDelivery.getMonth()];
      const new_delivered_day_date = getNextBusinessDayDelivery.getDate();
    /*console.log(`new_shipping_month = ${new_shipping_month},new_dispatched_date = ${new_dispatched_date}, new_delivered_day_date = ${new_delivered_day_date} `);*/
    document.getElementById("delivereddate").innerHTML = new_delivered_day_date + '<span class="delivereddate">'+new_shipping_month+'</span>';
    }
}, 5000);

}
